import * as fromActions from '../actions/areas.action'
import { Reducer } from 'redux'
import { IAreaModel } from './../../models/area.model'
import { IAreasState } from 'store/states/areas.state'

export const initialState: IAreasState = {
  areas: [] as IAreaModel[],
  loading: false,
}

export const reducer: Reducer<IAreasState> = (state: any = initialState, { type, payload }) => {
  switch (type) {
    case fromActions.GET_AREAS_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_AREAS_LIST_SUCCESS:
      return {
        ...state,
        areas: payload,
        loading: false,
      }
    default:
      return state
  }
}
